import trans from '../../../helpers/trans';
import { FormDataInterface, FormOption } from '../Form/Form';

export interface ParticipateFormData extends FormDataInterface {
    companyName: string;
    chamberOfCommerce: string;
    postalCode: string;
    houseNumber: string;
    addition?: string;
    street: string;
    city: string;
    country: string;
    assortmentDescription: string;
    signupReason: string;
    assortmentLocationPreference: string;
    assortmentSquareMeters: string;
    participantHistory: string;
    website?: string;
    pointsOfSaleOffline?: string;
    pointsOfSaleOnline?: string;
    firstName: string;
    insertion?: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    acceptTermsAndConditions: boolean;
}

const assortmentLocations = [
    'Loods 5 Amersfoort',
    'Loods 5 Duiven',
    'Loods 5 Maastricht',
    'Loods 5 Sliedrecht',
    'Loods 5 Zaandam',
    'Loods 5 Garage (outlet Zaandam)',
    'Loods5.nl',
];

const participantHistoryOptionsList = [
    trans('entities.participateForm.iAmNotAParticipant'),
    trans('entities.participateForm.haveBeenParticipantEarlier'),
    trans('entities.participateForm.iAmAParticipant'),
];

export const assortmentLocationOptions = assortmentLocations.map(label => ({
    label,
    value: label,
}));

export const participantHistoryOptions = participantHistoryOptionsList.map(label => ({
    label,
    value: label,
}));

export const assortmentSquareMeterOptions: FormOption[] = [
    {
        label: '10-20 m²',
        value: '10-20',
    },
    {
        label: '20-30 m²',
        value: '20-30',
    },
    {
        label: '30-50 m²',
        value: '30-50',
    },
    {
        label: '50+ m²',
        value: '50+',
    },
];
